
/* injects from baggage-loader */

import intro_bg1 from '_images/intro/intro-bg-1.png';
import intro_bg2 from '_images/intro/intro-bg-2.png';
import intro_bg3 from '_images/intro/intro-bg-3.png';
import intro_bg4 from '_images/intro/intro-bg-4.png';
import intro_bg5 from '_images/intro/intro-bg-5.png';
import intro_bg6 from '_images/intro/intro-bg-6.png';

import ending_bg0 from '_images/ending/ending0.png';
import ending_bg1 from '_images/ending/ending1.png';
import ending_bg2 from '_images/ending/ending2.png';
import ending_bg3 from '_images/ending/ending3.png';
import ending_bg4 from '_images/ending/ending4.png';
import ending_bg5 from '_images/ending/ending5.png';
import ending_bg6 from '_images/ending/ending6.png';
import ending_bg7 from '_images/ending/ending7.png';
import ending_bg8 from '_images/ending/ending8.png';
import ending_bgwhite from '_images/ending/ending-white.png';

export const intro_bg = [
  intro_bg1,
  intro_bg2,
  intro_bg3,
  intro_bg4,
  intro_bg5,
  intro_bg6
]

export const ending_bg = [
  ending_bg0,
  ending_bg1,
  ending_bg2,
  ending_bg3,
  ending_bg4,
  ending_bg5,
  ending_bg6,
  ending_bg7,
  ending_bg8,
  ending_bgwhite
]

export const ShapeConst = {
  sizes: {
    small: 1,
    big: 2
  },
  types: {
    circle: 1,
    triangle: 2,
    square: 3,
    rect: 4,
  },

  colors: {
    yellow: 1,
    red: 2,
    blue: 3,
  }
}

export const ShapeConstTranslate = {
  colors: {
    male: [
      'amarelos',
      'vermelhos',
      'azuis',
    ],
    female: [
      'amarelas',
      'vermelhas',
      'azuis',
    ],
  },
  types: [
    'círculos',
    'triângulos',
    'quadrados',
    'retângulos'
  ]
}


// WEBPACK FOOTER //
// ./src/app/index.const.js